import utils from '../../assets/js/utils'

const mutations = {
  setBaseData (state, data) {
    for (let item in data) {
      state[item] = data[item]
    }
  },

  // 设置基础配置参数
  SETBASECONFIGS (state, data) {
    state.baseConfigs = data
  },

  // 设置用户应用列表
  SETUSERAPPLIST (state, data) {
    state.userAppList = data
  },

  // 设置应用内数据列表
  SETAPPLISTDATA (state, data) {
    if (data.total > 0) {
      data.list.forEach(item => {
        item.sort = item.sort * 1
        item.originSort = item.sort * 1
      })
    }
    state.appListData = data
  },

  // 设置应用基本信息
  SETAPPBASEDATA (state, data) {
    let appBaseData = data
    appBaseData.year_id = appBaseData.year_id != 0 ? appBaseData.year_id * 1 : ''
    appBaseData.term_id = appBaseData.term_id != 0 ? appBaseData.term_id * 1 : ''
    appBaseData.grade_id = appBaseData.grade_id != 0 ? appBaseData.grade_id * 1 : ''
    state.appBaseData = appBaseData
  },

  SETAPPRELATIONCATALOGINFOS (state, data) {
    state.appRelationCatalogInfos = data
  },

  // 通过传入的item删除catalog下与item匹配的数据
  DELETE_CATALOG_BY_ITEM (state, item) {
    // 移除该目录和目录下的数据
    const doRemoveCatalog = ({ catalog }) => {
      if (catalog.length === 0) return

      for (const [index, data] of Object.entries(catalog)) {
        if (data === item) return catalog.splice(index, 1)
        const delItem = doRemoveCatalog(data.sub_catalog) // 深度优先遍历
        if (delItem) return delItem
      }
    }

    // 移除与之关联的游戏资源
    const doRemoveResource = data => {
      if (data.resource_info.length > 0) {
        data.resource_info.forEach(x => {
          delete state.appRelationCatalogInfos.relation_data[4][x.resource_id]
          data.sub_catalog.catalog.forEach(xx => doRemoveResource(xx))
        })
      }
    }

    const [delItem] = doRemoveCatalog(
      state.appRelationCatalogInfos.catalog_info
    )
    doRemoveResource(delItem)

    console.warn('被删除的目录 ===> ', delItem)
  },

  SET_APP_RELATION_CATALOG_INFOS (state, data) {
    state.appRelationCatalogInfos = data
  },

  // 通过网校试题ID向catalog中塞内容云的相关字段(jyy_resource_id、jyy_material_id)
  UPDATE_CATALOG_BY_ID (state, { id, jyyResourceId, jyyMaterialId }) {
    const data = state.appRelationCatalogInfos.catalog_info.catalog
    const recursiveSearch = data => {
      for (let index = 0; index < data.length; index++) {
        const item = data[index]
        const questions = item.resource_info.find(x => +x.resource_id === +id)
        if (questions) {
          return questions
        } else if (item.sub_catalog) {
          const nextLoopValue = recursiveSearch(item.sub_catalog.catalog)
          if (nextLoopValue) return nextLoopValue
        }
      }
    }
    const questions = recursiveSearch(data)
    if (questions) {
      questions.jyy_resource_id = jyyResourceId
      questions.jyy_material_id = jyyMaterialId
    }
  },

  // 设置应用配置
  SETAPPCONFIG (state, data) {
    state.appConfig = utils.deCopy(data)
    data.subject_ids = data.subject_ids.split(',')
    state.appEditConfigs = data
    utils.catalogTypes = []
    utils.getTypes(data.catalog, () => {
      state.catalogTypes = utils.deCopy(utils.catalogTypes)
    })
  },

  EMPTYAPPCONFIG (state) {
    state.appEditConfigs = {}
  },

  // 设置所有应用列表
  SETALLAPPLIST (state, data) {
    state.allAppList = data
  },

  // 获取基础信息配置信息（管理页面）
  SETBASESETTINGCONFIGS (state, data) {
    let config = []
    let extraConfig = []
    data.base_info_fields.forEach(item => {
      config.push({
        name: item.name,
        show_name: item.show_name,
        is_fixed_base_field: item.is_fixed_base_field + '',
        is_display_on_create: '1',
        is_required_on_create: '1',
        is_display: '1'
      })
    })
    data.extra_config.forEach(item => {
      extraConfig.push({
        type: item.type,
        name: item.name,
        show_name: item.show_name,
        is_open: item.default
      })
    })
    state.catalogTypes = []
    state.appEditBaseConfigs.config = config
    state.appEditBaseConfigs.extra_config = extraConfig
    state.appEditConfigs = utils.deCopy(state.appEditBaseConfigs)
  },

  // 设置资源库列表
  SETRESOURCELISTS (state, data) {
    state.resourceLists = data
  },

  // 设置组件
  SETCOMPONENTSLISTS (state, data) {
    state.componentsLists = data
  },

  // 设置positionList
  SETPOSITIONLIST (state, data) {
    state.positionList = data ? data : []
  },

  // 设置showIcon
  SETSHOWICON (state, data) {
    state.showIcon = data
  },
  // 设置navDrag
  SETNACDRAG (state, data) {
    state.navDrag = data
  },
  // 设置dragIndexList
  SETDRAGINDEXLIST (state, data) {
    state.dragIndexList = data
  },
  // 设置dragDeepth
  SETDRAGDEEPTH (state, data) {
    state.dragDeepth = data
  },
  // 设置dragParentCatalogId
  SETDRAGPARENTCATALOGID (state, data) {
    state.dragParentCatalogId = data
  },
  // 设置dragFailTip
  SETDRAGFAILTIP (state, data) {
    state.dragFailTip = data
  },
  // 设置dragIsFixed
  SETDRAGISFIXED (state, data) {
    state.dragIsFixed = data
  },
  // 设置一起读书&一起阅读预览数据
  SETREADARTICLEPREVIEWDATA (state, data) {
    state.readArticlePreviewData = data
  }
}
export default mutations



// WEBPACK FOOTER //
// ./common/commonModule/magicCube/vuex/magicCube/mutations.js